import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	templateUrl: "./studentabsenttardyexcuse.component.html",
})
export class StudentAbsentTardyExcuseComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,

		showDetail: "Yes",
		GroupID: 0,
		AttendanceStatusID: "Absent",
		SortBy: "Name",
		startDate: new Date(),
		endDate: new Date(),
		NumOfDaysID: 1,
		ExcuseID: "Excused And Unexcused",
		ImageLogo: "",
	};
	schoolList: any = [];

	lstNumberOfDays: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	//Excused And Unexcused|Excused Only|Unexcused Only
	excuseList = [
		{
			ExcuseID: "Excused And Unexcused",
			ExcuseDesc: "Excused And Unexcused",
		},
		{
			ExcuseID: "Excused Only",
			ExcuseDesc: "Excused Only",
		},
		{
			ExcuseID: "Unexcused Only",
			ExcuseDesc: "Unexcused Only",
		},
	];

	attendanceStatusList = [
		{
			AttendanceStatusID: "Absent",
			AttendanceStatusDesc: "Absent",
		},
		{
			AttendanceStatusID: "Tardy",
			AttendanceStatusDesc: "Tardy",
		},
		{
			AttendanceStatusID: "Both",
			AttendanceStatusDesc: "Both",
		},
		{
			AttendanceStatusID: "Present",
			AttendanceStatusDesc: "Present",
		},
		{
			AttendanceStatusID: "All",
			AttendanceStatusDesc: "All (Including Present)",
		},
	];

	lstShowDetail = [
		{
			ShowDetailDesc: "Yes",
		},
		{
			ShowDetailDesc: "No",
		},
	];
	lstSortBy = [
		{
			SortByDesc: "Name",
		},
		{
			SortByDesc: "Absent/Tardy",
		},
		{
			SortByDesc: "Homeroom",
		},
		{
			SortByDesc: "Grade",
		},
		{
			SortByDesc: "Count",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 151;

	subscription: any;

	ngOnInit() {
		this.loadNumDays();

		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(151);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadNumDays() {
		var i;
		for (i = 1; i <= 100; i++) {
			this.lstNumberOfDays.push({
				NumOfDays: i,
				NumOfDaysDesc: i.toString(),
			});
		}
		this.report.NumOfDaysID = this.lstNumberOfDays[0].NumOfDays;
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;

		//    this.AttendanceStatusList();
		//    this.ExcuseList();
		this.loadLogolist();
	}

	// private AttendanceStatusList() {
	//     this.report.AttendanceStatusID = 0;
	//     var result = this.reportService.AttendanceStatusGetList();
	//     result.subscribe(
	//         response => {
	//             this.attendanceStatusList = response;

	//             if (this.attendanceStatusList.length > 1) {
	//                 this.attendanceStatusList.unshift({
	//                     AttendanceStatusID: 0,
	//                     AttendanceStatusDesc: "All Attendance Status"
	//                 })
	//             } else {
	//                 this.report.AttendanceStatusID = this.attendanceStatusList[0].AttendanceStatusID
	//             }

	//         },
	//         error => {
	//         }
	//     )

	// }

	// private ExcuseList() {
	//     this.report.ExcuseID = 0;

	//     var result = this.reportService.ExcuseGetList();
	//     result.subscribe(
	//         response => {
	//             this.excuseList = response;

	//             if (this.excuseList.length > 1) {
	//                 this.excuseList.unshift({
	//                     ExcuseID: 0,
	//                     ExcuseDesc: "All Excuses"
	//                 })
	//             } else {
	//                 this.report.ExcuseID = this.excuseList[0].ExcuseID
	//             }

	//         },
	//         error => {
	//         }
	//     )

	// }

	Print() {
		var component = this;
		this.errorMessage = "";

		// if (!this.report.SchoolID) {
		//     this.errorMessage = "Select the School";
		//     return
		// }

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		// @SchoolXML
		// @Status
		// @STARTDATE
		// @ENDDATE
		// @NumberOf
		// @ORDERBY
		// @WExcuse
		// @ShowDetail
		// @ImageLogo

		var reportID = 151;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += "<ROOT><School SchoolID='" + this.report.SchoolID + "'/></ROOT>";
		strParam += "|SchoolXML";

		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");
		strParam += "," + this.report.AttendanceStatusID + "|Status";
		strParam += "," + startDate + "|STARTDATE";
		strParam += "," + endDate + "|ENDDATE";
		strParam += "," + this.report.NumOfDaysID + "|NumberOf";
		strParam += "," + this.report.SortBy + "|ORDERBY";
		strParam += "," + this.report.ExcuseID + "|WExcuse";
		strParam += "," + this.report.showDetail + "|ShowDetail";
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
